import type { IActivity } from "@/data/model/Audit";
import type { IActivityQry } from "@/data/queries/audit/ActivityQry";
import { DateTime } from "@/data/util/DateTime";

import { BaseServiceDao, type IDataSource, type IPaginatedResult, parsePaginatedResult } from "./BaseServiceDao";

export class AuditDao extends BaseServiceDao implements IDataSource<IActivity> {
    public static className = "AuditDao";

    constructor() {
        super("audit");
    }

    public async getData(qry: IActivityQry): Promise<IPaginatedResult<IActivity>> {
        return this.get("activity", qry, (f) => parsePaginatedResult(f, AuditDao.parseActivity));
    }

    /* public async getNotifications(): Promise<IPaginatedResult<INotification>> {
            return this.get('notification', undefined, (f) => parsePaginatedResult(f, AuditDao.parseNotification));
        }*/

    public static parseActivity(literal: any): IActivity {
        return {
            id: literal.id,
            created: DateTime.parseIsoDate(literal.created),
            message: literal.message,
            userName: literal.userName == null ? undefined : literal.userName,
            userInitials: literal.userInitials == null ? undefined : literal.userInitials,
            userId: literal.userId == null ? undefined : literal.userId,
            userAvatar: literal.userAvatar == null ? undefined : literal.userAvatar,
        };
    }

    /* public static parseNotification(literal: any): INotification {
            return {
                id: literal.id,
                created: DateTime.parseIsoDate(literal.created),
                typeName: literal.typeName,
                data: literal.data
            }
        }*/
}
